import React from "react";

const DownOutlined = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.6504 10.2312C12.6504 10.0503 12.5932 9.86935 12.4215 9.74874L8.12965 5.22613C7.84352 4.92462 7.44295 4.92462 7.15683 5.22613L2.86498 9.74874C2.57886 10.0503 2.57886 10.4724 2.86498 10.7739C3.15111 11.0754 3.55168 11.0754 3.8378 10.7739L7.67185 6.67337L11.5059 10.7136C11.792 11.0151 12.1926 11.0151 12.4787 10.7136C12.5932 10.593 12.6504 10.4121 12.6504 10.2312Z" fill="#4E5968"/>
    </svg>
  );
};

export default DownOutlined;